// ─────────────────────────────────────────────────────────────────────────────
// Service-worker registration — quarantined in its own module on purpose.
//
// The `new URL('../../sw.js', import.meta.url)` form is not just a URL: it is
// how Parcel DISCOVERS the worker, compiles it for the service-worker
// environment, and emits it at the site root. But `import.meta` is a parse
// error under Jest's CommonJS transform, so this file must never be imported
// from anything test-reachable. App.jsx (never imported by tests — the routing
// suite reads it as text) is the only caller; everything testable about PWA
// behaviour lives in src/lib/pwa.js.
//
// The guards are the feature:
//   • production bundles only — a worker over the dev server poisons every
//     reload, and Jest has no serviceWorker at all;
//   • automated browsers (Playwright sets navigator.webdriver) never
//     register, so e2e runs cannot leak cache state between tests;
//   • registration failure is silent — the app ran without a worker for
//     years and keeps working exactly the same without one.
// ─────────────────────────────────────────────────────────────────────────────

export function registerServiceWorker() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;
  if (navigator.webdriver) return;
  window.addEventListener('load', () => {
    // type: 'module' is what lets sw.js use ESM imports. Parcel resolves them
    // at build time and, since the emitted worker has none left, rewrites this
    // registration to a plain classic one — the option exists for the
    // bundler, not the browser.
    navigator.serviceWorker
      .register(new URL('../../sw.js', import.meta.url), { type: 'module', scope: '/' })
      .catch(() => {
        /* no worker → no offline support, nothing else changes */
      });
  });
}
